/**
 * EndNote guard — formatted EndNote citations (Cite While You Write
 * ``ADDIN EN.CITE`` fields) live only in the writer's Word document. An Asthra
 * redraft or a whole-document Load rewrites that text and would delete them.
 * Unformatted temporary citations ({Author, Year, …}) are plain text and are
 * re-emitted by every draft, so they need no guard.
 */

const UNFORMAT_HINT =
  "In Word's EndNote tab choose Convert Citations and Bibliography → Convert to Unformatted Citations, " +
  "then apply again (EndNote re-formats them with Update Citations and Bibliography).";

/** Writer-facing explanation when a destructive write is held back. */
export function endNoteOverwriteMessage(count: number, scope: "section" | "document"): string {
  const what = count === 1 ? "1 formatted EndNote citation" : `${count} formatted EndNote citations`;
  if (scope === "section") {
    return `This section has ${what}; the redraft was saved but not written into Word so they aren't lost. ${UNFORMAT_HINT}`;
  }
  return `This document has ${what}; loading replaces the whole document and would remove them. ${UNFORMAT_HINT} Or click Load again to replace it anyway.`;
}
